export default __webpack_public_path__ + "static/media/99dbe436c331a4430bad44349793fa82.svg";